import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useMemo } from "react";
import SignInWithGoogleButton from "app/pages/Auth/Google/SignInWithGoogleButton";
import { bindActionCreators } from "redux";
import { authSuccess, authWithGoogle } from "app/pages/Auth/AuthActions";

const mapStateToProps = state => {
	const googleClientId = state?.envVars?.GOOGLE_CLIENT_ID;
	return {
		source: state.marketing.source,
		googleClientId,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			authWithGoogle,
			authSuccess,
		},
		dispatch
	);
};

const SignInWithGoogleButtonContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const dispatch = useDispatch();
	const dispatchProps = useMemo(() => mapDispatchToProps(dispatch), [dispatch]);
	return <SignInWithGoogleButton {...props} {...stateProps} {...dispatchProps} />;
};

export default SignInWithGoogleButtonContainer;
